import React, { createContext, useContext, useState, useCallback } from "react";
import PropTypes from "prop-types";

const PlayerOccupiedZonesContext = createContext(null);

const INITIAL_STATE = {
  TOP_LEFT: { width: 0, height: 0, visible: false },
  TOP_RIGHT: { width: 0, height: 0, visible: false },
  BOTTOM_LEFT: { width: 0, height: 0, visible: false },
  BOTTOM_RIGHT: { width: 0, height: 0, visible: false },
  header: { height: 0, visible: false },
  footer: { height: 0, visible: false },
};

export function PlayerOccupiedZonesProvider({ children }) {
  const [zones, setZones] = useState(INITIAL_STATE);

  const registerZone = useCallback((zoneKey, zoneData) => {
    setZones((prev) => ({
      ...prev,
      [zoneKey]: {
        ...prev[zoneKey],
        ...zoneData,
      },
    }));
  }, []);

  const unregisterZone = useCallback((zoneKey) => {
    setZones((prev) => ({
      ...prev,
      [zoneKey]: INITIAL_STATE[zoneKey] || {
        width: 0,
        height: 0,
        visible: false,
      },
    }));
  }, []);

  const value = {
    zones,
    registerZone,
    unregisterZone,
  };

  return (
    <PlayerOccupiedZonesContext.Provider value={value}>
      {children}
    </PlayerOccupiedZonesContext.Provider>
  );
}

export function usePlayerOccupiedZones() {
  const context = useContext(PlayerOccupiedZonesContext);

  return context; // Возвращаем null если провайдера нет
}

PlayerOccupiedZonesProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
